import { render, staticRenderFns } from "./GroupFaculties.vue?vue&type=template&id=3124ed14"
import script from "./GroupFaculties.vue?vue&type=script&lang=js"
export * from "./GroupFaculties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports